import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import { AccessRule } from "./data-contracts";

export const postAppSecurityGetpermission = (id: number, data: any[], params?: IFetchConfig) =>
  fetch<AccessRule[]>("POST", `order/${id}/permission`, data, params);
